import { TAssessment } from "@/types/Assessment.types";
import { api, TCustomAxiosResponse } from "..";
import { useScreenerStore } from "@/store/useScreenerStore";
import { apiPaths } from '@/services/api/paths';

export const assessmentBySlugGet = async (slug: string): Promise<TAssessment> => {
  const { data } = await api.get<TCustomAxiosResponse<TAssessment>>(apiPaths.assessments.bySlug(slug));

  const assessment = data.data;

  const screenerStore = useScreenerStore.getState();

  // TODO: This is a side effect, it should be handled in a different way
  screenerStore.setScreenerId(assessment._id, assessment.slug);

  return assessment;
}

